window.onload = function () {
    // Classname reference

    function getHeight(elm) {
        var elmHeight, elmMargin;
        if(document.all) {// IE
            elmHeight = elm.offsetHeight;
            elmMargin = parseFloat(elm.currentStyle.marginTop) + parseFloat(elm.currentStyle.marginBottom);
        } else {// Mozilla
            elmHeight = parseFloat(elm.getBoundingClientRect().height);
            elmMargin = parseFloat(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseFloat(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
        }

        return Math.ceil(elmHeight+elmMargin);
    }

    const CLASSES = {
        MASONRY: 'masonry',
        PANEL: 'masonry-panel',
        PAD: 'masonry-pad'
    }

    class Masonry {
        constructor(el) {
            this.container = el
            this.panels = el.querySelectorAll(`.${CLASSES.PANEL}`)
            this.state = {
                heights: [],
            }
            this.layout();
        }

        /**
         * Reset the layout by removing padding elements, resetting heights
         * reference and removing the container inline style
         */
        __reset() {
            const {
                container,
            } = this
            this.state.heights = []
            const fillers = container.querySelectorAll(`.${CLASSES.PAD}`)
            if (fillers.length) {
                for (let f = 0; f < fillers.length; f++) {
                    fillers[f].parentNode.removeChild(fillers[f])
                }
            }
            container.removeAttribute('style')
        }

        /**
         * Iterate through panels and work out the height of the layout
         */
        __populateHeights() {
            const {
                panels,
                state,
            } = this
            const {
                heights,
            } = state
            for (let p = 0; p < panels.length; p++) {
                const panel = panels[p]
                const {
                    order: cssOrder,
                    msFlexOrder,
                } = getComputedStyle(panel)
                const height = getHeight(panel);
                const order = cssOrder || msFlexOrder;
                if (!heights[order - 1]) heights[order - 1] = 0
                heights[order - 1] += parseInt(height, 10)
            }
        }

        /**
         * Set the layout height based on referencing the content cumulative height
         * This probably doesn't need its own function but felt right to be nice
         * and neat
         */
        __setLayout() {
            const {
                container,
                state,
            } = this
            const {
                heights,
            } = state
            this.state.maxHeight = Math.max(...heights)
            container.style.height = `${this.state.maxHeight}px`
        }

        getWidth() {
            return Math.max(
                document.body.scrollWidth,
                document.documentElement.scrollWidth,
                document.body.offsetWidth,
                document.documentElement.offsetWidth,
                document.documentElement.clientWidth
            );
        }

        /**
         * JavaScript method for setting order of each panel based on panels.length and desired number of columns
         */
        __setOrders() {
            var width = this.getWidth();

            const {
                panels,
            } = this

            let cols = 1;

            if (width >= 550) {
                cols = 2;
            }
            if (width >= 990) {
                cols = 3;
            }
            if (width >= 1220) {
                cols = 4;
            }

            for (let f = 0; f < panels.length; f++) {
                panels[f].style.order = ((f + 1) % cols === 0) ? cols : (f + 1) % cols
            }
        }

        /**
         * Pad out layout "columns" with padding elements that make heights equal
         */
        __pad() {
            const {
                container,
            } = this
            const {
                heights,
                maxHeight,
            } = this.state
            heights.map((height, idx) => {
                if (height < maxHeight && height > 0) {
                    const pad = document.createElement('div')
                    pad.className = CLASSES.PAD
                    pad.style.height = `${maxHeight - height}px`
                    pad.style.order = idx + 1
                    pad.style.msFlexOrder = idx + 1
                    container.appendChild(pad)
                }
            })
        }

        /**
         * Resets and lays out elements
         */
        layout() {
            this.__reset()
            this.__setOrders()
            this.__populateHeights()
            this.__setLayout()
            this.__pad()
            $(`.${CLASSES.MASONRY}`).hide();
            $(`.${CLASSES.MASONRY}`).css('visibility','visible');
            $(`.${CLASSES.MASONRY}`).show();
        }
    }
if(document.querySelector(`.${CLASSES.MASONRY}`)!=null){
    window.myMasonry = new Masonry(document.querySelector(`.${CLASSES.MASONRY}`))
    /**
     * To make responsive, onResize layout again
     * NOTE:: For better performance, please debounce this!
     */
    window.addEventListener('resize', () => myMasonry.layout())}
};
